export enum ResourceTypeQueryKeys {
  GetAll = "GetAll"
}
